import React, { useState, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom'
import { useNotification } from '../hooks';
import { groupAppsByCategory } from '../helpers'
import { apps } from '../apps'

export const Home = () => {

  const { notifications, updateNotifications } = useNotification()
  const groupedApps = groupAppsByCategory(apps)

  const [viewMode, setViewMode] = useState('grid') // 'grid' | 'table'

  useLayoutEffect(() => {
    setViewMode(localStorage.getItem('homeViewMode') === 'table' ? 'table' : 'grid')
  }, [])

  const changeViewMode = (mode) => {
    setViewMode(mode)
    localStorage.setItem('homeViewMode', mode)
  }

  return (
    <div className={"Home"}>

      <div className="home-header">
        <div className="home-view-switch">
          <button type="button" className={"home-view-btn" + (viewMode === 'grid' ? ' active' : '')} onClick={() => changeViewMode('grid')}>Rutnät</button>
          <button type="button" className={"home-view-btn" + (viewMode === 'table' ? ' active' : '')} onClick={() => changeViewMode('table')}>Tabell</button>
        </div>
      </div>

      {
        groupedApps.map(group => (
          <section className="app-category" key={group.key}>
            <h2 className="app-category-label">{group.label}</h2>

            <div className={viewMode === 'grid' ? "app-grid" : "app-table"}>

              {
                group.apps.map(([key, app]) => {
                  const notificationCount = notifications && notifications[app.name].total

                  const content = viewMode === 'grid'
                    ? (
                      <>
                        <div className="app-icon">
                        {app.AppIcon &&
                          <app.AppIcon />
                        }
                        { notificationCount > 0 &&
                          <div className="app-notification">{notificationCount}</div>
                        }
                        </div>
                        <div className="app-name">
                          {app.displayName}
                        </div>
                      </>
                    )
                    : (
                      <>
                        <div className="app-table-icon">
                        {app.AppIcon &&
                          <app.AppIcon />
                        }
                        </div>
                        <div className="app-table-name">
                          {app.displayName}
                        </div>
                        { notificationCount > 0 &&
                          <div className="app-notification">{notificationCount}</div>
                        }
                      </>
                    )

                  return (
                    <div className={viewMode === 'grid' ? "app-grid-container" : "app-table-row"} key={key}>
                      <Link to={ "/" + app.name }>{content}</Link>
                    </div>
                  )
                })
              }
            </div>
          </section>
        ))
      }

    </div>
  );
}
